module.exports = __webpack_public_path__ + "e72f8b1eb1b18d5e1dbe6214d8b25e14.svg";